import React, { lazy, Suspense } from "react";
import { Chip, Divider } from "@mui/material";
import Div from "@jumbo/shared/Div";
import RenderHTML from "components/RenderHTML";
import SkeletonCard from "components/Skeleton";
import { HEIGHT_OFFSET } from "app/utils/constants/constants";
import { purple } from "@mui/material/colors";
import ErrorView from "components/ErrorView";
import { useNavigate } from "react-router-dom";
// Fallback component while the dynamic component is loading
const LoadingFallback = () => (
  <SkeletonCard width="80%" count={3} height={50} />
);

const VisualizationTab = ({ problemData }) => {
  const navigate = useNavigate();
  // A fallback component for when the module is not found
  const NotFoundComponent = () => (
    <ErrorView
      error={"Visualization not available for this problem"}
      // onBack={() => navigate("/")}
      // backButtonLabel="Back"
    />
  );

  const DynamicComponent = problemData?.name
    ? lazy(() =>
        import(
          `app/pages/visualization/algorithms/${problemData.name}.js`
        ).catch(() => {
          // If the file is not found or another error occurs, return a dummy component
          return {
            default: NotFoundComponent,
          };
        })
      )
    : null;

  return problemData ? (
    <Div
      sx={{
        p: 2,
        height: `calc(100vh - ${HEIGHT_OFFSET.DEFAULT})`,
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      {DynamicComponent ? (
        <Suspense fallback={<LoadingFallback />}>
          <DynamicComponent />
        </Suspense>
      ) : (
        <div>Component not found</div>
      )}
    </Div>
  ) : (
    <LoadingFallback />
  );
};

export default VisualizationTab;
